import FooterLogo from "../Images/5.png";
import { Link } from "react-router-dom";
import { IoIosCall } from "react-icons/io";
import { LuMail } from "react-icons/lu";
import { MdOutlineLocationOn } from "react-icons/md";
import { FaInstagramSquare, FaLinkedin } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaTwitterSquare } from "react-icons/fa";
import "./Footer.css";
import { GrYoutube } from "react-icons/gr";

const Footer = () => {
  return (
    <>
      <div className="max-w-[1456px] mx-auto">
        <div className="mt-6 w-full sticky">
          <div className="lg:flex items-center justify-around bg-[#469B8F] w-full pt-4 pb-4">
            <div>
              <img
                src={FooterLogo}
                className="w-[200px] h-[150px] block mx-auto"
              />
              <span className="bg-[#F7F7F7] w-56 lg:text-xl text-center   md:w-50 lg:w-80 p-1   block mx-auto text-[#469B8F]  rounded-lg   font-roboto font-bold text-sm">
                Path towords happiness...
              </span>
            </div>
            <div className="text-[#F7F7F7] pl-16 lg:pl-0">
              <h1 className="text-3xl font-roboto pt-10">Links</h1>
              <ul className="">
                <li className="pt-2 text-[18px] hover:text-black  font-roboto">
                  <Link to={"/Home"}>Home</Link>
                </li>
                <li className="pt-2 text-[18px] hover:text-black font-roboto">
                  <Link to={"/AboutHospital"}> About</Link>
                </li>
                <li className="pt-2 text-[18px] hover:text-black  font-roboto">
                  <Link to={"/Mentalillness"}>Service</Link>
                </li>
                <li className="pt-2 text-[18px]  hover:text-black font-roboto">
                  <Link to={"/Blog1"}>Blog</Link>
                </li>
                <li className="pt-2 text-[18px] hover:text-black  font-roboto">
                  <Link to={"/Photos"}>Gallery</Link>
                </li>
                <li className="pt-2 text-[18px] hover:text-black  font-roboto">
                  <Link to={"/ContactUs"}>Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className=" text-[#F7F7F7] pl-16 lg:pl-0">
              <div>
                <p className="text-3xl font-roboto  pt-10"> Get in touch</p>
                <p className="font-roboto pt-5 flex   lg:w-full  md:w-[80%] items-center text-[16px]">
                  <MdOutlineLocationOn className="pr-2 text-[30px] " />
                  419, Time Shoppers, Nr. Amiras Restaurant,
                  <br /> B/s Millennium Business Hub, Sarthana Jakatnaka, <br />{" "}
                  Surat, Gujarat - 395013
                </p>
              </div>
              <div className="pt-3">
                <p className="flex items-center text-[16px]">
                  <LuMail className="pr-2 text-[25px]" />
                  Dr.Anant@psynexa.in
                </p>
              </div>
              <div className="pt-3">
                <p className=" flex items-center text-[16px] ">
                  <IoIosCall className="pr-2 text-[25px]" /> +91 85758 88887
                </p>
              </div>
              <div className="flex gap-3 pt-3">
                <a href="https://www.instagram.com/psynexa_/">
                  <FaInstagramSquare className="text-2xl rounded-xl" />
                </a>
                <a href="https://www.facebook.com/share/15G9kb7Wfb/?mibextid=wwXIfr">
                  <FaFacebookSquare className="text-2xl rounded-xl " />
                </a>
                <a href="https://www.youtube.com/@dranantchangela">
                  <GrYoutube className="text-2xl rounded-xl " />
                </a>

                <a href="https://www.linkedin.com/in/dr-anant-changela-9a5312363">
                  <FaLinkedin className="text-2xl rounded-xl " />
                </a>
              </div>
            </div>
          </div>
        </div>
        

        <div className="bg-gray-100 text-gray-700 py-6 px-6 sm:px-12 md:px-24">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

            <p className="text-center sm:text-left text-sm sm:text-base">
              © 2025 Psynexa Mind Care Hospital. All rights reserved.
            </p>

            {/* Social Icons */}
            <div className="flex justify-center sm:justify-start gap-3">
              <a
                href="https://www.instagram.com/psynexa_/"

                className="text-2xl rounded-xl  transition-colors duration-300"
              >
                <FaInstagramSquare />
              </a>
              <a
                href="https://www.facebook.com/share/15G9kb7Wfb/?mibextid=wwXIfr"

                className="text-2xl rounded-xl transition-colors duration-300"
              >
                <FaFacebookSquare />
              </a>
              <a
                href="https://www.youtube.com/@dranantchangela"

                className="text-2xl rounded-xl transition-colors duration-300"
              >
                <GrYoutube />
              </a>
              <a
                href="https://www.linkedin.com/in/dr-anant-changela-9a5312363"

                className="text-2xl rounded-xl  transition-colors duration-300"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>



      </div>
    </>
  );
};

export default Footer;
